import React from 'react';
import { PageHeader } from '../components/shared/PageHeader';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/card';
import { Label } from '../components/ui/label';
import { Switch } from '../components/ui/switch';
import { Button } from '../components/ui/button';
import { toast } from 'sonner';
export function SettingsPage() {
  const handleSave = () => {
    toast.success('Nastavitve so bile shranjene');
  };
  return <div className="max-w-3xl mx-auto space-y-6" data-id="element-373">
      <PageHeader title="Nastavitve" description="Upravljanje sistemskih nastavitev in preferenc." data-id="element-374" />

      <Card data-id="element-375">
        <CardHeader data-id="element-376">
          <CardTitle data-id="element-377">Splošne nastavitve</CardTitle>
          <CardDescription data-id="element-378">Osnovne nastavitve aplikacije.</CardDescription>
        </CardHeader>
        <CardContent className="space-y-6" data-id="element-379">
          <div className="flex items-center justify-between" data-id="element-380">
            <div className="space-y-0.5" data-id="element-381">
              <Label className="text-base" data-id="element-382">Obvestila po e-pošti</Label>
              <p className="text-sm text-slate-500" data-id="element-383">
                Prejemanje obvestil o novih nalogih.
              </p>
            </div>
            <Switch defaultChecked data-id="element-384" />
          </div>

          <div className="flex items-center justify-between" data-id="element-385">
            <div className="space-y-0.5" data-id="element-386">
              <Label className="text-base" data-id="element-387">Samodejno shranjevanje</Label>
              <p className="text-sm text-slate-500" data-id="element-388">
                Shrani osnutek med urejanjem.
              </p>
            </div>
            <Switch defaultChecked data-id="element-389" />
          </div>

          <div className="flex items-center justify-between" data-id="element-390">
            <div className="space-y-0.5" data-id="element-391">
              <Label className="text-base" data-id="element-392">Kompaktni pogled tabel</Label>
              <p className="text-sm text-slate-500" data-id="element-393">
                Prikaži več vrstic na zaslonu.
              </p>
            </div>
            <Switch data-id="element-394" />
          </div>

          <div className="pt-4" data-id="element-395">
            <Button onClick={handleSave} data-id="element-396">Shrani nastavitve</Button>
          </div>
        </CardContent>
      </Card>
    </div>;
}